import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useHomeIdentity } from '../../hooks/useHomeIdentity';
import { HomeAssignedTickets } from './HomeAssignedTickets';
import { HomePullRequests } from './HomePullRequests';

export const HomeWorkQueues = () => {
  const classes = useStyles();
  const config = useApi(configApiRef);
  const backendUrl = config.getString('backend.baseUrl');
  const { homeUser, githubSyncInProgress, refreshIdentity } =
    useHomeIdentity(backendUrl);

  return (
    <Box className={classes.queues}>
      <HomeAssignedTickets backendUrl={backendUrl} email={homeUser.email} />
      <HomePullRequests
        backendUrl={backendUrl}
        githubUsername={homeUser.githubUsername}
        githubSyncInProgress={githubSyncInProgress}
        refreshIdentity={refreshIdentity}
      />
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  queues: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(3),
    alignItems: 'start',
    '@media (max-width: 1000px)': { gridTemplateColumns: '1fr' },
  },
}));
